<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      size="small"
      :height="tableHeight - 6"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>

      <template v-slot:isSpecify="{ row }">
        <el-tag size="mini" :type="row.isSpecify === 'Y' ? 'light' : 'info'">
          {{ row.v_isSpecify }}
        </el-tag>
      </template>
      <template v-slot:isCustomerProvide="{ row }">
        <el-tag
          size="mini"
          :type="row.isCustomerProvide === 'Y' ? 'light' : 'info'"
        >
          {{ row.v_isCustomerProvide }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="$emit('openDetailDialog', row)"
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>
